import { render, staticRenderFns } from "./SettlementLedgerTab.vue?vue&type=template&id=1f8abdf4&scoped=true"
import script from "./SettlementLedgerTab.vue?vue&type=script&lang=js"
export * from "./SettlementLedgerTab.vue?vue&type=script&lang=js"
import style0 from "./SettlementLedgerTab.vue?vue&type=style&index=0&id=1f8abdf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8abdf4",
  null
  
)

export default component.exports